// frontend/src/services/assignmentService.js
import api from './api';

// --- Teacher -> Subject ---
export const getTeacherSubjectAssignments = async (teacherId) => {
    const response = await api.get(`/assignments/teacher/${teacherId}/subjects`);
    return response.data;
};

export const saveTeacherSubjectAssignments = async (teacherId, subjectIds) => {
    const response = await api.post('/assignments/teacher-subjects', {
        teacher_id: teacherId,
        subject_ids: subjectIds,
    });
    return response.data;
};

// --- Teacher/Subject -> Class ---
export const getClassAssignments = async (classId) => {
    const response = await api.get(`/assignments/class/${classId}/assignments`);
    return response.data;
};

export const saveClassAssignments = async (classId, assignments) => {
    const response = await api.post('/assignments/class-assignments', {
        class_id: classId,
        assignments: assignments,
    });
    return response.data;
};


export const getTutorGroup = async (teacherId) => {
    const response = await api.get(`/assignments/tutor-group/${teacherId}`);
    return response.data;
};

// --- Class -> Subject ---
export const getClassSubjects = async (classId) => {
    const response = await api.get(`/assignments/class/${classId}/subjects`);
    return response.data;
};

export const saveClassSubjects = async (classId, subjectIds) => {
    const response = await api.post('/assignments/class-subjects', {
        class_id: classId,
        subject_ids: subjectIds
    });
    return response.data;
};

export const saveTutorGroup = async (teacherId, studentIds) => {
    const response = await api.post('/assignments/tutor-group', {
        teacher_id: teacherId,
        student_ids: studentIds
    });
    return response.data;
};